export default function($rootScope, $timeout, $compile) {
  "ngInject";
  return function(scope, element, attrs) {

    scope.$watch(function(scope) {
      return scope.$parent.vm.contentArray;
    }, (newVal, oldVal) => {
      $timeout(() => {
        var html = angular.element(element[0]).html();
        // Datatable
        html = html.replace(/\[companies(?:\s+filter=(?:&quot;|["\u201C\u201D\u201E])([^"&\u201C\u201D\u201E]*)(?:&quot;|["\u201C\u201D\u201E]))?(?:\s+event_id=(?:&quot;|["\u201C\u201D\u201E])([^"&\u201C\u201D\u201E]*)(?:&quot;|["\u201C\u201D\u201E]))?\]/g, function(match, filter, eventId) {
          var filterAttr = "'" + (filter || '') + "'";
          var eventIdAttr = eventId ? " data-event-id=\"'" + eventId + "'\"" : '';
          return '<datatable data-filter="' + filterAttr + '"' + eventIdAttr + '></datatable>';
        });
        // YouTube
        html = html.replace(/\[youtube\s+id=(?:&#34;|&quot;|["\u201C\u201D\u201E])([^"&#\u201C\u201D\u201E]*)(?:&#34;|&quot;|["\u201C\u201D\u201E])\]/g, function(match, videoId) {
          return '<img src="youtube:' + videoId + '" class="youtube-marker" style="display:none" />';
        });
        // Social Wall
        html = html.replace('[socialwall]', '<iframe allowfullscreen id="wallsio-iframe" src="https://my.walls.io/ekf?nobackground=1&amp;show_header=0&amp;show_post_info=1&amp;accessibility=0" style="border:0;height:calc(100vh - 30px);width:100%" loading="lazy" allow="camera" title="ekf"></iframe>');
        angular.element(element[0]).html(html
          .replace('[programm day="0"]', '<scheduler day="\'0\'"></scheduler>')
          .replace('[programm day="1"]', '<scheduler day="\'1\'"></scheduler>')
          .replace('[programm day="2"]', '<scheduler day="\'2\'"></scheduler>'));
        $compile(element.contents())(scope);
      });
    });

  }
}



// WEBPACK FOOTER //
// ./client/app/common/directives/parse.directive.js